import { EventEmitter } from '@angular/core';
import { FilterExpression, FilterProvider } from '../interfaces/filter-provider.interface';

/**
 * No-Op FilterProvider für Apps ohne Filter-Feature.
 * Alle Methoden sind funktionslose Stubs.
 */
export class NullFilterProvider implements FilterProvider {
	readonly filteredDocIds = new Set<string>();
	readonly filtersUpdated = new EventEmitter<void>();
	readonly apply = new EventEmitter<void>();

	async list_keys(): Promise<string[]> { return []; }
	async get(_key: string): Promise<FilterExpression | undefined> { return undefined; }
	async set(_key: string, _value: FilterExpression): Promise<void> { }
	async remove(_key: string): Promise<void> { }
	async getAll(): Promise<Record<string, object>> { return {}; }

	async applyFilter(_name: string): Promise<void> { }
	async resetFilter(): Promise<void> { }

	setFilteredDocIds(_ids: Set<string> | string[]): void { }
	setFilterFunc(_exp: FilterExpression): void { }
	applyFilterClientSide(_docs: unknown[]): void { }

	setFilterBounds(_bounds: { l: { x: number; y: number }; u: { x: number; y: number } } | null): void { }

	async storeViews(_name: string, _exp: FilterExpression, _withBounds: boolean, _bnds: {l: {x: number, y: number}, u: {x: number, y: number}}[], _callback: Function): Promise<void> { }
}
